module.exports = __webpack_public_path__ + "static/media/RES.83affc98.jpg";